const { jQuery: $, themeSettings: config } = window;
import Theme from './modules/theme.class';
import Utils from "./modules/utils.class";

const utils = new Utils();
const theme = new Theme(
    config,
    utils,
);

$(() => theme.__onReady());
$(window).on('load', () => theme.__onLoad());
$(window).on('resize', () => theme.__onResize());

$(window).on('kpf:ready', (event, api) => theme.__postFilters(api));

window.Theme = theme;

Utils.log("Loading Theme...");